import axios from '@/libs/http'
/**
 * 获取订单详情
 */
export const getInfo = (id) => {
  return axios.request({
    url: '/s/c/user-select-clerk-condition/get',
    params: {
      id
    },
    method: 'get'
  })
}

export const getRandomList = (pageNo, pageSize) => {
  return axios.request({
    url: '/s/c/user-select-clerk-condition/randomList',
    params: {
      pageNo,
      pageSize
    },
    method: 'get'
  })
}

/**
 * 确认订单
 */
export const respond = (id) => {
  return axios.request({
    url: '/s/c/clerk-respond-user/respond',
    params: {
      id
    },
    method: 'post'
  })
}